// Stamps the resolved customer id on <html> so the generated tenant
// stylesheet's :root[data-tenant="<id>"] block applies from the first
// server-rendered paint (and follows dev tenant switches, which reload).
import { computed, defineNuxtPlugin, useHead } from '#imports'
import { useTenant } from '../composables/useTenant'

export default defineNuxtPlugin(() => {
	const { customer } = useTenant()
	useHead({ htmlAttrs: { 'data-tenant': computed(() => customer.value?.id ?? '') } })
})
